import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button, TextField } from '@mui/material';
import { AlarmData } from '../Alarm Functions/AlarmOverviewFunctions'
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting } from 'devextreme-react/data-grid';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import ColumnCellTemplateData from 'devextreme/ui/data_grid'
import PhoneInput from 'react-phone-input-2'
import { AlarmContactsHandle } from '../Alarm Functions/AlarmOverviewFunctions'
import Loader from '../../Utils/Loader/NewLoader2025'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';




interface Recipients {
    id: number
    email: string
    mobile: string | undefined
    enabledWhatsApp: boolean
    enabledSMS: boolean
    enabledEmail: boolean
    isUser: boolean
}

interface User {
    id: number;
    userGuid: string;
    email: string;
    level: string;
    lockout: string;
    companyId: number;
    lastLogin: Date | null;
    config: boolean | null;
    company: string | null
    parentId: number | null
}
interface APIRecipients extends Recipients {
    companyId: string | null
}

interface Props {
    triggerSave: boolean | null
    onSaveComplete: () => void
    companyId: number | null
}



const AlarmContacts: React.FC<Props> = ({triggerSave, onSaveComplete, companyId }) => {


    //hooks
    const intl:IntlShape = useIntl()

    //state

    const [users, setUsers] = useState<Recipients[]>([])
    const [tempContact, setTempContact] = useState<Recipients>({
        id: 0,
        email: "",
        mobile: "",
        enabledWhatsApp: false,
        enabledSMS: false,
        enabledEmail: false,
        isUser: false
    })
    const [hoveredContact, setHoveredContact] = useState<Recipients | undefined>()
    const [editClicked, setEditClicked] = useState<boolean>(false)
    const [notificationClicked, setNotificationClicked] = useState<string>('')
    const [addCustom, setAddCustom] = useState<boolean>(false)
    const [usersToBeSentToAPI, setUsersToBeSentToAPI] = useState<Recipients[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const iconStyle = {
        fontSize: '33px',
        cursor: 'pointer'
    }


    const overViewStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 0 0 0",
        width: "90%",
        boxShadow: "2px 2px 10px #00000060",
    }


    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }));

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Check console for details' }), 5000, () => {
            alert('error');
        });
    };

    useEffect(() => {
        reloadData()
    }, [])

    const reloadData = ():void => {
        setLoading(true)
        CallGetAPI(CreateUrl(`/api/aquaguard/Users?companyId=${companyId}`), {})
            .then(data => {
                CallGetAPI(CreateUrl(`/api/aquaguard/ContactsForCompany?companyId=${companyId}`), {})
                    .then(contactData => {

                        let contactInfo: Recipients[] = []

                        contactData.forEach((con: Recipients) => {

                            contactInfo.push({
                                id: con.id,
                                email: con.email,
                                mobile: con.mobile,
                                enabledWhatsApp: con.enabledWhatsApp,
                                enabledSMS: con.enabledSMS,
                                enabledEmail: con.enabledEmail,
                                isUser: data.map(d => d.email).includes(con.email) ? true : false
                            })
                        })
                        data.forEach((usr: User) => {
                            if (!contactData.map(c => c.email).includes(usr.email)) {
                                contactInfo.push({
                                    id: 0,
                                    email: usr.email,
                                    mobile: undefined,
                                    enabledWhatsApp: false,
                                    enabledSMS: false,
                                    enabledEmail: false,
                                    isUser: data.map(d => d.email).includes(usr.email) ? true : false
                                })
                            }
                        })

                        contactInfo = userSortFunction(contactInfo)

                        setUsers(contactInfo)
                        setLoading(false)
                    })
                    .catch(err => {
                        console.error(err)
                        setLoading(false)
                    })


            })
            .catch(err => console.error(err))
    }

    useEffect(() => {
        if (triggerSave) {
            handleSave()
        }
    }, [triggerSave])

    useEffect(() => {
        if (usersToBeSentToAPI.length > 0 && triggerSave === null) {
            handleSave()
        }
    }, [usersToBeSentToAPI])


    const userSortFunction = (usersInput: Recipients[]): Recipients[] => {
        usersInput.sort((a, b) => {
            const hasNotificationA = a.enabledEmail || a.enabledSMS || a.enabledWhatsApp ? 1 : 0
            const hasNotificationB = b.enabledEmail || b.enabledSMS || b.enabledWhatsApp ? 1 : 0

            const notificationComparison = hasNotificationB - hasNotificationA
            if (notificationComparison !== 0) return notificationComparison
            return a.email.localeCompare(b.email)
        })
        return usersInput
    }

    const renderNotificationIcons = (data: ColumnCellTemplateData): React.ReactNode => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <i
                    className="fa-solid fa-envelope"
                    onClick={(): void => handleNotificationClick('email', data.data.email)}
                    style={{ ...iconStyle, color: data.data.enabledEmail ? 'green' : 'gray' }}></i>
                {/*!window.location.hostname.includes('zonelog.net') && <i
                    className="fas fa-sms"
                    onClick={(): void => handleNotificationClick('sms', data.data.email)}
                    style={{ ...iconStyle, color: data.data.enabledSMS ? 'green' : 'gray' }}></i>*/}
                {!window.location.hostname.includes('zonelog.net') && <i
                    className="fa-brands fa-square-whatsapp"
                    onClick={(): void => handleNotificationClick('whatsapp', data.data.email)}
                    style={{ ...iconStyle, color: data.data.enabledWhatsApp? 'green' : 'gray' }}></i>}
            </div>
        )
    }

    const handleNotificationClick = (type: string, email: string): void => {
        if (addCustom) return
        const usersTemp = users.map(usr => {
            if (usr.email === email) {
                if (type === 'email') {
                    usr.enabledEmail = usr.enabledEmail ? false : true
                } else {
                    if (usr.mobile) {
                        if (type === 'sms') {
                            usr.enabledSMS = usr.enabledSMS ? false : true
                        }
                        if (type === 'whatsapp') {
                            usr.enabledWhatsApp = usr.enabledWhatsApp ? false : true
                        }
                    } else {
                        setTempContact(users.find(u => u.email === email))
                        setEditClicked(true)
                        setNotificationClicked(type)
                        
                    }
                }
                if (!usersToBeSentToAPI.map(u => u.email).includes(email)) {
                    // if user has not been added
                    setUsersToBeSentToAPI([...usersToBeSentToAPI, usr])
                } else {
                    const filteredUsers = usersToBeSentToAPI.filter(u => u.email !== email)
                    setUsersToBeSentToAPI([...filteredUsers, usr])
                }
                
            }
            
            return usr
        })
        //usersTemp = userSortFunction(usersTemp)
        setUsers(usersTemp)

    }


    const handleMouseEnter = (email: string): void => {
        if (!editClicked) {
            setHoveredContact(users.find(u => u.email === email))
        }
    }

    const editBtnClicked = (email: string): void => {
        setTempContact(users.find(u => u.email === email))
        setEditClicked(true)
    }

    const handleMobileInput = (num: string): void => {
        const contact = { ...tempContact }
        contact.mobile = num
        setTempContact(contact)
    }

    const renderExternalUser = (data): React.ReactNode => {
        if (data.data.isUser) {
            return <p><FormattedMessage id="No" /></p>
        } else {
            return <p><FormattedMessage id="Yes" /></p>
        }
      
    }

    const handleSaveClicked = (email: string): void => {

        const usersTemp = users.map(usr => {
            if (usr.email === email) {
                usr.mobile = tempContact?.mobile
                if (notificationClicked === 'sms') {
                    usr.enabledSMS = true
                }
                if (notificationClicked === 'whatsapp') {
                    usr.enabledWhatsApp = true
                }
                if (!usersToBeSentToAPI.map(u => u.email).includes(email)) {
                    // if user has not been added
                    setUsersToBeSentToAPI([...usersToBeSentToAPI, usr])
                } else {
                    const filteredUsers = usersToBeSentToAPI.filter(u => u.email !== email)
                    setUsersToBeSentToAPI([...filteredUsers, usr])
                }
            }


            return usr
        })

        setUsers(usersTemp)
        setNotificationClicked('')
        setEditClicked(false)
       
    }


    const renderPhoneNumberCell = (data: ColumnCellTemplateData): React.ReactNode => {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    height: 35
                }}
                onMouseOver={(): void => handleMouseEnter(data.data.email)}
                onMouseOut={(): void => setHoveredContact(undefined)}
            >
                {editClicked && tempContact?.email === data.data.email ?
                    <div style={{ display: 'flex' }}>
                        <PhoneInput
                            value={tempContact?.mobile}
                            onChange={(num): void => handleMobileInput(num)}
                            inputStyle={{ width: 250 }} country={'gb'}
                        />
                        <Button
                            variant='contained'
                            onClick={(): void => handleSaveClicked(data.data.email)}
                            color="warning"
                            disabled={addCustom}
                        >
                            <FormattedMessage id="Add" />
                        </Button>
                    </div>
                    :
                    <p style={{ width: '100%' }}>{data.data.mobile}</p>
                }
                {hoveredContact?.email === data.data.email &&
                    <Button
                        variant='contained'
                        disabled={addCustom}
                        style={{ flex: 'flex-end' }}
                        color={'secondary'}
                        onClick={(): void => editBtnClicked(data.data.email)}>
                        <FormattedMessage id="Edit" />
                    </Button>
                }
            </div>
        )
    }

    const handleCustomReceipent = (): void => {

        setAddCustom(true)
        setTempContact({
            id: 0,
            email: "",
            mobile: "",
            enabledWhatsApp: false,
            enabledSMS: false,
            enabledEmail: false,
            isUser: false
        })
    }

    const handleCustomEmailChange = (email: string): void => {
            const contact: Recipients = { ...tempContact }
            contact.email = email
            setTempContact(contact)
    }

    const handleCustomNotifications = (type:string):void => {
        const contact = { ...tempContact }
        if (type === 'email') {
            contact.enabledEmail = !contact.enabledEmail
        }
        if (type === 'sms') {
            contact.enabledSMS = !contact.enabledSMS
        }
        if (type === 'whatsapp') {
            contact.enabledWhatsApp = !contact.enabledWhatsApp
        }
        setTempContact(contact)
    }

    const handleCustomClose = ():void => {
        setAddCustom(false)
        setTempContact({
            id: 0,
            email: "",
            mobile: "",
            enabledWhatsApp: false,
            enabledSMS: false,
            enabledEmail: false,
            isUser: false
        })
    }

    const handleAddToContacts = (): void => {
        let usersTemp = [...users]
        usersTemp.push(tempContact)
        usersTemp.sort((a, b) => {
            const emailA = a.email.toUpperCase()
            const emailB = b.email.toUpperCase()
            if (emailA < emailB) return -1
            if (emailA > emailB) return 1
            return 0
        })
        setUsersToBeSentToAPI([...usersToBeSentToAPI, tempContact])
        usersTemp = userSortFunction(usersTemp)
        setUsers(usersTemp)
        setTempContact({
            id: 0,
            email: "",
            mobile: "",
            enabledWhatsApp: false,
            enabledSMS: false,
            enabledEmail: false,
            isUser: false
        })
        setAddCustom(false)
    }


   


    const handleSave = (): void => {
        const postData: APIRecipients[] = []
        usersToBeSentToAPI.forEach((usr: APIRecipients) => {
            usr.companyId = companyId
            postData.push(usr)
        })
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        }

        CallPostAPI(CreateUrl('/api/Contacts/Contacts'), requestOptions)
            .then(data => {
                createSuccessNotification()
            })
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })

        onSaveComplete()
    }

    const renderEmail = (data, intl: IntlShape): React.ReactNode => { 
            return (
                <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                    onMouseOver={(): void => handleMouseEnter(data.data.email)}
                    onMouseOut={(): void => setHoveredContact(undefined)}
                >
                    <p>{data.data.email}</p>
                    {hoveredContact?.email === data.data.email &&
                        <Button color="error" variant="contained" onClick={():void => handleContactDelete(data.data.id, intl) }>
                            <FormattedMessage id="Delete" />
                        </Button>
                    }
                </div>
            )
    }


    const handleContactDelete = (id: number, intl: IntlShape):void => {
        const confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to delete this alarm recipient, this will remove them form all alarms that they are set to receive?' }))
        if (confirm) {
            CallDeleteAPI(CreateUrl(`/api/aquaguard/Contact?id=${id}`), {})
                .then(data => {
                    createSuccessNotification()
                    reloadData()
                })
                .catch(err => {
                    createErrorNotification()
                    console.error(err)
                })
        }
    }

    return (
        <div>
            {loading &&
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    zIndex: 13000,
                    height: 300
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading && <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '80%' }}>
                    {!addCustom && <Button variant='contained' onClick={(): void => handleCustomReceipent()} style={{ marginBottom: 10 }}><FormattedMessage id="Add Custom Recipient" /></Button>}
                    {addCustom &&
                        <div style={{
                            ...overViewStyle,
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            margin: '20px 0',
                            padding: '20px',
                            borderLeft: "10px solid #00bf00"
                        }}>
                            <div style={{ width: '80%', marginRight: 10 }}>
                                <p><b><FormattedMessage id="Email" /> *</b></p>
                                <TextField
                                    fullWidth
                                    onChange={(e): void => handleCustomEmailChange(e.target.value)}
                                    value={tempContact?.email}
                                    type='email'
                                />
                            </div>
                            {!window.location.hostname.includes('zonelog.net') && <div style={{ margin: '0 10px' }}>
                                <p><b>{`${intl.formatMessage({ id: 'Phone Number' })} ${tempContact?.enabledWhatsApp || tempContact?.enabledSMS ? '*' : ''}`}</b></p>
                                <PhoneInput
                                    value={tempContact?.mobile}
                                    onChange={(num): void => handleMobileInput(num)}
                                    inputStyle={{ width: 300, height: 56 }} country={'gb'}

                                />
                            </div>}
                            <div style={{ width: 300 }}>
                                <p><b><FormattedMessage id="Which Notifications" /></b></p>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 25 }}>

                                    <i
                                        className="fa-solid fa-envelope"
                                        onClick={(): void => handleCustomNotifications('email')}
                                        style={{ ...iconStyle, color: tempContact?.enabledEmail ? 'green' : 'gray' }}></i>
                                    {/*!window.location.hostname.includes('zonelog.net') && <i
                                        className="fas fa-sms"
                                        onClick={(): void => handleCustomNotifications('sms')}
                                        style={{ ...iconStyle, color: tempContact?.enabledSMS ? 'green' : 'gray' }}></i>*/}
                                    {!window.location.hostname.includes('zonelog.net') && <i
                                        className="fa-brands fa-square-whatsapp"
                                        onClick={(): void => handleCustomNotifications('whatsapp')}
                                        style={{ ...iconStyle, color: tempContact?.enabledWhatsApp ? 'green' : 'gray' }}></i>}
                                </div>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <Button
                                        variant='contained'
                                        color="error"
                                        style={{ margin: '47px 10px 0 0' }}
                                        onClick={(): void => handleCustomClose()}
                                    >
                                        <FormattedMessage id="Close" />
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        variant='contained'
                                        color="warning"
                                        style={{ marginTop: 47 }}
                                        disabled={
                                            !tempContact?.email ||
                                            (!tempContact?.mobile &&
                                                (tempContact?.enabledSMS || tempContact?.enabledWhatsApp)
                                            )
                                        }
                                        onClick={(): void => handleAddToContacts()}
                                    >
                                        <FormattedMessage id="Add" />
                                    </Button>
                                </div>
                            </div>
                        </div>}

                    {users && users.length > 0 &&

                        <DataGrid
                            dataSource={users}
                        >
                            <StateStoring enabled={true} type="localStorage" storageKey="alarmContactGrid" />
                            <Export enabled={false} />
                            <FilterRow visible={true} />
                            <HeaderFilter visible={true} search={{ enabled: true }} />
                            <Column dataField='email' dataType="string" cellRender={(data): React.ReactNode => renderEmail(data, intl)} caption={intl.formatMessage({id: 'Email'})}  />
                            {!window.location.hostname.includes('zonelog.net') && <Column dataField='mobile' caption={intl.formatMessage({ id: 'Mobile Number' })} cellRender={(data): React.ReactNode => renderPhoneNumberCell(data)} width='325' />}
                            <Column dataField="isUser" caption={intl.formatMessage({ id: "External User" })} cellRender={(data): React.ReactNode => renderExternalUser(data)} width={200} />
                            <Column cellRender={(data): React.ReactNode => renderNotificationIcons(data)} width='200' caption={intl.formatMessage({ id: 'Which Notifications' })} />
                            <Paging defaultPageSize={10} />

                        </DataGrid>
                    }
                </div>
            </div>}
        </div>
    )
}
export default AlarmContacts